import React from 'react';

const Legal = () => {
  const phoneNumber = '336-354-1040';

  return (
    <div data-testid="legal-page">
      {/* Hero */}
      <section className="py-10 md:py-24 bg-slate-50">
        <div className="w-full max-w-[1120px] mx-auto px-4 md:px-8">
          <h1 className="text-3xl sm:text-5xl md:text-6xl font-heading font-bold text-slate-900 mb-4 md:mb-6 tracking-tight">
            Legal Disclaimers
          </h1>
          <p className="text-base md:text-xl text-slate-600 leading-relaxed max-w-[720px]">
            Important information about the use of this website and the legal services provided by Rizzi Law Group.
          </p>
        </div>
      </section>

      {/* Disclaimers */}
      <section className="py-10 md:py-24 bg-white">
        <div className="w-full max-w-[1120px] mx-auto px-4 md:px-8">
          <div className="max-w-[820px] mx-auto space-y-8 md:space-y-12 text-slate-600 leading-relaxed">
            <div>
              <h2 className="text-2xl font-heading font-semibold text-slate-900 mb-4">
                No Attorney-Client Relationship or Legal Advice
              </h2>
              <p>
                The information on this website is for general informational purposes only. Nothing on this site should be 
                taken to create an attorney-client relationship or constitute legal advice. An attorney-client relationship 
                is formed only through a signed engagement agreement. Do not send us confidential information until an 
                attorney-client relationship has been established.
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-heading font-semibold text-slate-900 mb-4">
                Case Results
              </h2>
              <p>
                Prior results do not guarantee a similar outcome. Every case is unique and must be evaluated on its own merits. 
                The outcome of your case will depend on the facts and circumstances specific to your situation.
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-heading font-semibold text-slate-900 mb-4">
                Million Dollar Advocates Forum
              </h2>
              <p>
                Membership in the Million Dollar Advocates Forum is limited to attorneys who have obtained verdicts or 
                settlements in excess of one million dollars. Membership does not indicate superiority or special competence 
                and is not an endorsement by the Forum.
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-heading font-semibold text-slate-900 mb-4">
                Attorney Advertising
              </h2>
              <p>
                This website constitutes attorney advertising. The choice of a lawyer is an important decision and should 
                not be based solely upon advertisements.
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-heading font-semibold text-slate-900 mb-4">
                Stock Photography
              </h2>
              <p>
                Some images on this website are stock photographs and do not depict actual clients, attorneys, or staff 
                of Rizzi Law Group.
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-heading font-semibold text-slate-900 mb-4">
                External Links
              </h2>
              <p>
                This website may contain links to external websites. Rizzi Law Group is not responsible for the content 
                of external sites and does not endorse or make representations about them.
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-heading font-semibold text-slate-900 mb-4">
                Electronic Communications
              </h2>
              <p>
                Email and internet communications are not secure. Please do not send confidential information via email. 
                For urgent matters, please call us at {phoneNumber}.
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-heading font-semibold text-slate-900 mb-4">
                Errors and Omissions
              </h2>
              <p>
                While we strive to provide accurate and up-to-date information, this website may contain technical 
                inaccuracies or typographical errors. Information may be changed or updated without notice.
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-heading font-semibold text-slate-900 mb-4">
                Tennessee Bar Notice
              </h2>
              <p>
                The Supreme Court of Tennessee does not recognize certification of specialties in the practice of law, 
                and we do not claim specialist certification in Tennessee.
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-heading font-semibold text-slate-900 mb-4">
                Disclaimer
              </h2>
              <p>
                THIS WEBSITE AND ITS CONTENTS ARE PROVIDED "AS IS" WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, 
                INCLUDING BUT NOT LIMITED TO WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, OR NON-INFRINGEMENT.
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Legal;